<div class="h-100 p-2">
    <app-packages-table-view [packagesAPI]="packagesAPI" [canPrintPdf]="true" (printPdf)="downloadPdf()"></app-packages-table-view>
</div>
